import React, { useEffect } from "react";
import { useQuery } from "@apollo/client";
import withStyles from '@mui/styles/withStyles';
import Box from "@mui/material/Box";
import { GET_CAMPAIGNS_WITH_EXISITING_CODES_QUERY, GET_STATISTICS_QUERY } from "../../queries/queries";
import Error from "../error";
import Loading from "../loading";
import CouponCampaignList from "./coupon-campaign-list";

const styles = (theme) => ({
  root: {
    fontFamily: "Montserrat",
  },
  logoutIcon: {
    zIndex: 200,
    position: "absolute",
    right: 24,
    top: 40,
    color: "#fff",
  },
  couponsAmount: {
    color: "black",
    fontSize: "18px",
    fontWeight: "bold",
    letterSpacing: "0.36px",
    textAlign: "center",
    width: "100%",
    margin: "5px 0px",
  },
  couponsTitle: {
    color: "gray",
    fontSize: "12px",
    letterSpacing: "0.36px",
    textAlign: "center",
    width: "100%",
    margin: "10px 0px 20px",
  },
});

const Coupons = ({ classes }) => {
  const { loading, error, data } = useQuery(
    GET_CAMPAIGNS_WITH_EXISITING_CODES_QUERY,
    {
      fetchPolicy: "no-cache",
    }
  );

  const statisticsResult = useQuery(GET_STATISTICS_QUERY, {
    fetchPolicy: "no-cache",
  });
  const availablePoints = statisticsResult?.data?.statistics?.availablePoints;

  useEffect(() => {
    const wrapper = document.querySelector(".scrollable");
    if (!wrapper) return;

    document.querySelector(".scrollable").addEventListener(
      "touchmove",
      function(event) {
        event.stopPropagation();
      },
      false
    );
  });

  if (loading) return <Loading />;
  if (error) return <Error />;

  const removeExpiredCouponsFilter = (campaign) => {
    return new Date(campaign.expiresAt.replace(/-/g, "/")) > new Date();
  };
  let campaigns = data.campaignsWithValidCodes.filter(
    removeExpiredCouponsFilter
  );
  
  return (
    <Box data-testid="campaign" style={{ marginTop: 220, marginBottom: 100 }}>
      <div className="scrollable">
        <Box className={classes.root}>
          {availablePoints >= 0 &&
            <div className={classes.couponsAmount}>Verfügbare Punkte: {availablePoints}</div>
          }
          <div className={classes.couponsTitle}>VERFÜGBARE COUPONS:</div>
          <CouponCampaignList campaigns={campaigns} />
        </Box>
      </div>
    </Box>
  );
};

export default withStyles(styles)(Coupons);
